import {useState} from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox,
  Avatar,
  Button,
  Pagination,
  PaginationItem
} from "@mui/material";
import { Doughnut } from "react-chartjs-2";
import Anaytics from "../../assets/images/admin/anaytics.png.png"
import Anaytics1 from "../../assets/images/admin/analytics1.png.png"
import Avthar from "../../assets/images/admin/avthar.jpg.png"


const visitorData = [
  { label: "Male", percentage: "0.78%", count: "18,235", color: "#6200ea" },
  { label: "Female", percentage: "1.57%", count: "12,743", color: "#ff5722" },
  { label: "Others", percentage: "0.32%", count: "5,369", color: "#4caf50" },
  { label: "Not Mentioned", percentage: "19.45%", count: "16,458", color: "#2196f3" },
];
const ordersData = [
  {
    product: "Classic tufted leather sofa",
    image: Anaytics,
    category: "Furniture",
    quantity: 1,
    customer: { name: "Lucas Hayes", avatar: Avthar },
    status: "Shipped",
    price: "₹1200.00",
    date: "2024-05-18",
  },
  {
    product: "Rose Flower Pot",
    image: Anaytics1,
    category: "Decoration",
    quantity: 2,
    customer: { name: "Abigail Scott", avatar: Avthar },
    status: "Delivered",
    price: "₹250.00",
    date: "2024-05-19",
  },
  {
    product: "Leather Handbag",
    image: Anaytics,
    category: "Fashion",
    quantity: 1,
    customer: { name: "Mason Wallace", avatar: Avthar },
    status: "Processing",
    price: "₹800.00",
    date: "2024-05-20",
  },
  {
    product: "Polaroid Medium Camera",
    image: Anaytics1,
    category: "Electronics",
    quantity: 3,
    customer: { name: "Chloe Lewis", avatar: Avthar },
    status: "Pending",
    price: "₹50.00",
    date: "2024-05-20",
  },
  {
    product: "Digital Watch",
    image: Anaytics,
    category: "Fashion",
    quantity: 2,
    customer: { name: "Henry Morgan", avatar: Avthar },
    status: "Shipped",
    price: "₹100.00",
    date: "2024-05-21",
  },
];


const chartData = {
  labels: visitorData.map((item) => item.label),
  datasets: [
    {
      data: visitorData.map((item) => parseInt(item.count.replace(",", ""), 10)),
      backgroundColor: visitorData.map((item) => item.color),
      borderWidth: 0,
    },
  ],
};


const chartOptions = {
  plugins: {
    legend: { display: false },
    tooltip: { enabled: false },
  },
  cutout: "85%",
  rotation: -90,
  circumference: 180,
  responsive: true,
  maintainAspectRatio: false,
};
const getStatusColor = (status) => {
    switch (status) {
      case "Shipped":
        return { backgroundColor: "#e0e7ff", color: "#6366f1" }; 
      case "Delivered":
        return { backgroundColor: "#dcfce7", color: "#16a34a" };
      case "Processing":
        return { backgroundColor: "#fee2e2", color: "#dc2626" }; 
      case "Pending":
        return { backgroundColor: "#fef3c7", color: "#d97706" }; 
      default:
        return { backgroundColor: "#f3f4f6", color: "#374151" }; 
    }
  };
 

const AdminAnalytics = () => {
    const [currentPage, setCurrentPage] = useState(1);
    const entriesPerPage = 5;
    const totalEntries = 10; 
  
    const handlePageChange = (event, value) => {
      setCurrentPage(value);
    };
  
  return (
    <Box display="flex" gap={2} p={2} pt={50}sx={{ flexDirection: { xs: "column", md: "row" } }}>
      <Card sx={{ width: { xs: "100%", md: "30%" }, mb: { xs: 2, md: 0 } }}>
        <CardContent>
          <Typography variant="h6" textAlign="center" gutterBottom>
            Visitors By Gender
          </Typography>
          <Box sx={{ position: "relative", height: 200 }}>
            <Doughnut data={chartData} options={chartOptions} />
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                textAlign: "center",
              }}
            >
              <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "bold" }}>
                Total Visitors
              </Typography>
              <Typography variant="h4" sx={{ fontWeight: "bold", color: "#333" }}>
                52,805
              </Typography>
            </Box>
          </Box>
          <Box mt={2}>
            {visitorData.map((item) => (
              <Box
                key={item.label}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                mb={1}
              >
                <Box display="flex" alignItems="center" gap={1}>
                  <Box
                    sx={{
                      width: 12,
                      height: 12,
                      borderRadius: "50%",
                      backgroundColor: item.color,
                    }}
                  />
                  <Typography>{item.label}</Typography>
                </Box>
                <Typography>{item.count}</Typography>
              </Box>
            ))}
          </Box>
        </CardContent>
      </Card>
      <Card sx={{ width: { xs: "100%", md: "70%" } }}>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Recent Orders
          </Typography>
          <TableContainer component={Paper}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox />
                  </TableCell>
                  <TableCell>Product</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Customer</TableCell>
                  <TableCell>Status</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Ordered Date</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {ordersData.map((order, index) => (
                  <TableRow key={index}>
                    <TableCell padding="checkbox">
                      <Checkbox />
                    </TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <img src={order.image} alt={order.product} width="50" />
                        <Typography>{order.product}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>{order.category}</TableCell>
                    <TableCell>{order.quantity}</TableCell>
                    <TableCell>
                      <Box display="flex" alignItems="center" gap={1}>
                        <Avatar src={order.customer.avatar} alt={order.customer.name} />
                        <Typography>{order.customer.name}</Typography>
                      </Box>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        size="small"
                        sx={{
                          borderRadius: "20px",
                          fontWeight: "bold",
                          textTransform: "capitalize",
                          ...getStatusColor(order.status),
                        }}
                      >
                        {order.status}
                      </Button>
                    </TableCell>
                    <TableCell>{order.price}</TableCell>
                    <TableCell>{order.date}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
        <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}mb={2} px={2}>
      <Typography variant="body2">Showing {entriesPerPage} Entries</Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Button
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
          disabled={currentPage === 1}
          sx={{
            color: currentPage === 1 ? "#9e9e9e" : "#000",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Prev
        </Button>
        <Pagination
          count={Math.ceil(totalEntries / entriesPerPage)}
          page={currentPage}
          onChange={handlePageChange}
          renderItem={(item) => (
            <PaginationItem
              {...item}
              sx={{
                "&.Mui-selected": {
                  backgroundColor: "#004d4d", 
                  color: "#fff",
                  borderRadius: "5px",
                  fontWeight: "bold",
                },
              }}
            />
          )}
        />
        <Button
          onClick={() => setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalEntries / entriesPerPage)))}
          disabled={currentPage === Math.ceil(totalEntries / entriesPerPage)}
          sx={{
            color: currentPage === Math.ceil(totalEntries / entriesPerPage) ? "#9e9e9e" : "#000",
            textTransform: "none",
            fontWeight: "bold",
          }}
        >
          Next
        </Button>
      </Box>
    </Box>
      </Card>
    
    </Box>
  );
};

export default AdminAnalytics;
